









  import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
  import Util from '@/lib/util'
  import AbpBase from '@/lib/abpbase'
  import HzbLetterView from "@/views/jm/jobdo/hz/hzbletter.vue";

  @Component({
     components: {HzbLetterView}
  })
export default class HZBHomeView extends AbpBase {
     currview:string=""
     async created(){
        this.currview= this.$route.name;
     }
      @Watch('$route')
        routeChange(to:any){
          this.currview=to.name; 
        }
  }
